<template>
  <p
    :class="[
      'hit-rate__value',
      'title',
      'u-m-a-0',
      size,
      hitRateColorClass,
    ]"
  >
    {{ convertFractionToPercent(hitGoalPercentage) }}<span :class="['hit-rate__percent', size]">%</span>
  </p>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { convertFractionToPercent } from '@/helpers/numberHelpers';

export default {
  name: 'HitRate',

  props: {
    activeUserId: {
      type: String,
      required: true,
    },
    activeTeamId: {
      type: String,
      required: false,
      default: null,
    },
    size: {
      type: String,
      required: false,
      validator(propValue) {
        // The value must match one of these strings
        /* @ TODO -- more sizes 'xsmall', 'small', */
        return ['small', 'medium', 'large', 'x-large'].indexOf(propValue) !== -1;
      },
      default: 'medium',
    },
  },

  data() {
    return {
      isEditingGoal: false,
      isGoalDetailModalOpen: false,
    };
  },

  computed: {
    ...mapState({
      users: state => state.user.users,
      teams: state => state.team.teams,
    }),
    ...mapGetters([
      'activeWorkspace',
      'loggedInUser',
    ]),
    activeUser() {
      return this.users[this.activeUserId];
    },
    activeTeam() {
      return this.teams[this.activeTeamId];
    },
    totalGoalCount() {
      return Object.values(this.goalCountsMinusUnmarked).reduce((a, b) => (a + b), 0);
    },
    goalCountsMinusUnmarked() {
      let goalMetrics;
      if (this.activeUserId) {
        goalMetrics = { ...this.activeUser.goalMetrics };
      } else if (this.activeTeamId) {
        const users = this.activeTeam.userIds.map(userId => this.users[userId]);

        goalMetrics = {
          '0': users.reduce((total, user) => (total + user.goalMetrics['0']), 0), // eslint-disable-line
          '1': users.reduce((total, user) => (total + user.goalMetrics['1']), 0), // eslint-disable-line
          '2': users.reduce((total, user) => (total + user.goalMetrics['2']), 0), // eslint-disable-line
          '3': users.reduce((total, user) => (total + user.goalMetrics['3']), 0), // eslint-disable-line
        };
      }

      delete goalMetrics['0'];

      return goalMetrics;
    },
    hitGoalPercentage() {
      return this.totalGoalCount > 0 ? this.goalCountsMinusUnmarked['1'] / this.totalGoalCount : 0;
    },
    hitRateColorClass() {
      let className = '';
      if (this.hitGoalPercentage > 0.9) {
        className = 'has-text-success';
      } else if (this.hitGoalPercentage > 0.8) {
        className = 'has-text-info';
      } else if (this.hitGoalPercentage > 0.7) {
        className = 'has-text-warning';
      } else if (this.totalGoalCount === 0) {
        className = 'has-text-grey-light';
      } else {
        className = 'has-text-danger';
      }

      return className;
    },
  },

  methods: {
    convertFractionToPercent,
  },
};
</script>

<style lang="scss" scoped>
.columns {
  &:not(:last-child) {
    border-bottom: 1px solid $grey-lighter;
  }
}

.hit-rate__value {
  &.small {
    font-size: $size-7;
  }

  &.medium {
    font-size: $size-6;
  }

  &.large {
    font-size: $size-5;
  }

  &.x-large {
    font-size: $size-3;
  }
}

.hit-rate__percent {
  &.small {
    font-size: 0.6rem;
  }

  &.medium {
    font-size: $size-7;
  }

  &.large {
    font-size: $size-6;
  }

  &.x-large {
    font-size: $size-6;
  }
}
</style>
